import React from 'react';
import { PricingPage } from '@/pages/PricingPage';

export function PricingPageRoute() {
  const token = localStorage.getItem('storycraft_token');
  const isLoggedIn = Boolean(token);

  return (
    <main className="relative z-10 min-h-screen bg-black text-white selection:bg-[#2DD4BF]/30">
      <PricingPage isLoggedIn={isLoggedIn} />
    </main>
  );
}

export default PricingPageRoute;
